import styled from "styled-components";
import { ButtonContained, ButtonText, FontStyles } from "../../../components";
import { Spacing } from "../../../config";

const Container = styled.div(({ theme, $dark, $row }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: $dark
      ? theme.palette.action.selected
      : theme.palette.background.papr,

    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});

const ContainerSecondary = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    backgroundColor: theme.palette.action.selected,
    paddingBlock: "20px",
    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});
const ButtonContainer = styled.div(({ theme }) => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row",
    gap: theme.spacing(1),
  };
});
const Submit = styled(ButtonContained)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      backgroundColor: theme.palette.action.active,
      borderRadius: 100,
      ...FontStyles.semibold12,
      paddingInline: theme.spacing(2.5),
      paddingBlock: theme.spacing(1.9),
    },
  };
});
const Clear = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      color: theme.palette.action.selected,
      ...FontStyles.semibold12,
      paddingInline: theme.spacing(2.5),
      paddingBlock: theme.spacing(1.9),
    },
  };
});


const ImageLabel = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b5ca6",
    margin: 0,
    textTransform: "capitalize",
    paddingBottom: "8px",
    "@media (max-width: 1500px)": {
      paddingBottom: "6px",
      fontSize: "10px",
    },
    "@media (max-width: 600px)": {
      paddingBottom: "4px",
      fontSize: "9px",
    },
  };
});

const ImageBox = styled.div(({ theme }) => {
  return {
    width: "100%",
    aspectRatio: "1",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "#f0f0f0",
    display: "flex",
    alignItems: "center",
    height: "31.5vh",
    justifyContent: "center",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },

    "@media (max-width: 1300px)": {
      height: "50vh",
    },
    "@media (max-width: 960px)": {
      height: "30vh",
      width: "35vw",
      display: "flex",
    },
    "@media (max-width: 600px)": {
      height: "25vh",
      alignItems: "center",
      justifyContent: "center",
      width: "40vw",
    },
  };
});



const CardsGrid = styled.div(({ theme }) => {
  const { breakpoints } = theme;
  return {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "12px",
    width: "100%",
    [breakpoints.down("lg")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  };
});

const Card = styled.div(({ theme }) => {
  return {
    backgroundColor: "#E9E9E9",
    borderRadius: "10px",
    padding: "16px",
    boxShadow: "0 0 0 1px rgba(0,0,0,0.04)",
    minHeight: "80px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 1500px)": {
      padding: "12px",
      minHeight: "70px",
    },
    "@media (max-width: 960px)": {
      padding: "10px",
      minHeight: "65px",
    },
    "@media (max-width: 600px)": {
      padding: "8px",
      minHeight: "55px",
    },
  };
});


const CardValue = styled.div(({ theme }) => {
  return {
    backgroundColor: "#E9E9E9",
    borderRadius: "10px",
    marginTop: 10,
    padding: "16px",
    border:"none",
    minHeight: "80px",
    width:"auto",
    height:"11vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 1500px)": {
      padding: "12px",
      minHeight: "70px",

    },
    "@media (max-width: 1095px)": {
      padding: "10px",
      minHeight: "65px",
    },
    "@media (max-width: 600px)": {
      padding: "8px",
      minHeight: "55px",
    },
  };
});

const CardTitle = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b5ca6",
    margin: 0,
    paddingBottom: "8px",
    textTransform: "uppercase",
    "@media (max-width: 1500px)": {
      paddingBottom: "6px",
      fontSize: "10px",
    },
    "@media (max-width: 600px)": {
      paddingBottom: "4px",
      fontSize: "9px",
    },
    TextTransform: "capitalize",
  };
});

const CardContent = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b2b2b",
    margin: 0,
    whiteSpace: "normal",
    wordBreak: "break-word",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "4px",
    "@media (max-width: 1500px)": {
      fontSize: "11px",
      gap: "2px",
    },
    "@media (max-width: 600px)": {
      fontSize: "10px",
      flexDirection: "column",
      alignItems: "flex-start",
    },
  };
});


const Barra = styled.div(({ theme }) => {
  return {
    width: "60vw",
    backgroundColor: "#E6E6E6",
    marginTop: theme.spacing(4),
    marginLeft: -30,
    height: "5px",
  };
});
const OnUse = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    paddingInline: theme.spacing(1.625),
    paddingBlock: theme.spacing(1),
    backgroundColor: "#4D585A",
    color: "white",
    borderRadius: theme.spacing(2),
    margin: 0,
  };
});

const RegitryContainer = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
  };
});

const RegitryButton = styled(ButtonContained)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      backgroundColor: "white",
      color: colors.text.primary,
      marginTop: 0,
      ...FontStyles.medium14,

      "&:hover": {
        backgroundColor: colors.primary.contrastText,
      },

      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});

const CancelButton = styled(ButtonText)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      marginTop: 0,
      ...FontStyles.medium14,
      color: "white",
      paddingInline: spacing(2),
      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});
const ViewButton = styled(ButtonContained)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      backgroundColor: colors.primary.main,
      color: colors.text.secondary,
      paddingBlock: "6px",
      paddingInline: "13px",
      marginTop: 0,
      ...FontStyles.medium12,

      "&:hover": {
        backgroundColor: colors.text.primary,
      },

      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});

const Label = styled.p(({ theme, $withError, $color, white }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.semibold12,
    textTransform: "capitalize",
    padding: 0,
    margin: 0,
    color: "#2b5ca6",
    transition: ".2s",
    pointerEvents: "none",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
    paddingTop: spacing(1.5),
  };
});

const Value = styled.p(({ theme, $withError, $color, white }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium14,
    paddingBlock: spacing(1.25),
    color: "#272727",
    width: "100%",
    borderBottom: "1px solid #fff",
    margin: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    wordBreak: "break-all",
  };
});

const InnerPanel = styled.div(({ theme }) => {
  return {
    backgroundColor: theme.palette.background.default || "#FFFFFF",
    borderRadius: 8,

    width: "100%",
    padding: 20,
    paddingInline: 20,
    boxSizing: "border-box",
    maxHeight: "420px",
    overflowY: "auto",
  };
});

const FieldGrid = styled.div(({ theme }) => {
  return {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(1.5),
    alignItems: "start",
    marginBottom: theme.spacing(2),
  };
});

const FieldCard = styled.div(({ theme }) => {
  return {
    backgroundColor: "#E9E9E9",
    borderRadius: 10,
    width: "100%",
    padding: theme.spacing(3),
    boxShadow: "0 0 0 1px rgba(0,0,0,0.04)",
    minHeight: 56,
    overflowX: "auto",
    overflowY: "hidden",
    "&::-webkit-scrollbar": {
      height: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#999",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  };
});

const FieldTitle = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: theme.palette.primary.main || "#2b5ca6",
    margin: 0,
    paddingBottom: theme.spacing(0.5),
    textTransform: "uppercase",
  };
});

const FieldContent = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b2b2b",
    margin: 0,
    paddingTop: 5,
    whiteSpace: "nowrap",
    overflow: "hidden",
  };
});

const ContainerFilter = styled.div(({ theme, noLine }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    padding: "16px 20px",
    paddingInline: noLine && 0,
    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});
const ValueSpan = styled.span(({ theme, $disabled }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium12,

    color: "white",

    margin: 0,
    cursor: "pointer",
    textDecoration: "underline",
    display: "flex",
    gap: "4px",
    alignItems: "center",
    opacity: $disabled && 0.33,
  };
});
const Styles = {
  Container,
  Submit,
  Clear,
  ButtonContainer,
  ContainerFilter,
  OnUse,
  RegitryContainer,
  RegitryButton,
  ContainerSecondary,
  CancelButton,
  ViewButton,
  Label,
  Value,
  ValueSpan,
  InnerPanel,
  FieldGrid,
  FieldCard,
  FieldTitle,
  FieldContent,
  Barra,
  ImageBox,
  ImageLabel,
  Card,
  CardValue,
  CardContent,
  CardTitle,
  CardsGrid,
};

export default Styles;
